import { useState } from "react";
import { CaratClosedIcon } from "../controls/ThermalHeatMapSvgs";
import { EnvParams } from "./ThermalHeatMapSummary";

export interface EnvironmentalSectionProps {
  envParams: EnvParams;
  defaultOpen?: boolean;
}

const ENV_PARAM_CONFIG: Array<{ key: keyof EnvParams; label: string; unit: string }> = [
  { key: "albedo_factor", label: "Albedo of Earth", unit: "-" },
  { key: "blackbody_temperature", label: "Blackbody Temperature", unit: "K" },
  { key: "solar_constant", label: "Solar Constant", unit: "W/m²" },
];

const EnvironmentalSection: React.FC<EnvironmentalSectionProps> = ({
  envParams,
  defaultOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`thermal-heatmap-summary-box `}>
      <div className="thermal-heatmap-summary-header-row" onClick={() => setIsOpen((v) => !v)}>
        <button className="thm-summary-toggle-btn">
          <span
            style={{
              display: "flex",
              transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 300ms ease",
            }}
          >
            <CaratClosedIcon active={isOpen} />
          </span>
        </button>
        <div className="thermal-heatmap-summary-header">ENVIRONMENTAL</div>
      </div>
      {isOpen && (
        <div className="thermal-heatmap-face-summary-box">
          <div className="thm-env-tab">
            {ENV_PARAM_CONFIG.map(({ key, label, unit }) => {
              const val = envParams[key];
              return (
                <div key={key} className="thm-env-param-row">
                  <span className="thm-env-param-label">{label}</span>
                  <span className="thm-env-param-value">
                    {val !== null ? `${val}${unit && unit !== "-" ? ` ${unit}` : ""}` : "—"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default EnvironmentalSection;
